import { onBeforeUnmount, watch } from 'vue'

import { isDesktopViewport } from '../utils/viewport'

import type { WatchSource } from 'vue'

const DIALOG_OPENED_CLASS = 'bx-js-dialog-opened'

// Marks the body as "dialog opened" (locks background scrolling) while an overlay is open on mobile viewports.
export function useMobileDialogBodyClass (isOpen: WatchSource<boolean>, { scrollToTop = false } = {}) {
  watch(isOpen, (open) => {
    const isMobileDialog = open && !isDesktopViewport()
    if (isMobileDialog && scrollToTop) scroll(0, 0)
    document.body.classList.toggle(DIALOG_OPENED_CLASS, isMobileDialog)
  })

  onBeforeUnmount(() => {
    document.body.classList.remove(DIALOG_OPENED_CLASS)
  })
}
